import { Box, Stack, TextField, Button, Tooltip, Typography, FormControlLabel, Checkbox } from '@mui/material'
import { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const RoleMaster = () => {
    const history = useHistory();
    const [state, setState] = useState({
        therapy_master_data: [],
        role_name: '',
        role_code: null,
        is_active: true,
        edit_id: null,
        is_loader: false,
        // deleted_ids: [],
        selected_ids: [],
        is_inactive: false,
        is_delete: false,
        checkbox_list: [],
        page: 0,
        pageSize: 10,
        //toast msg state
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: "",
    });

    useEffect(() => {
        getRoleMasterList()
    }, [])

    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    const successMessage = (message) => {
        updateState({
            successMsg: true,
            successMsgText: message
        })
    }

    const errorMessage = (message) => {
        updateState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    const msgClose = () => {
        updateState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ""
        })
    }

    const getRoleMasterList = () => {
        try {
            updateState({ is_loader: true })
            RestAPIService.getAll(Serviceurls.ROLE_MASTER_GET)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const Data = response.data.data || []
                        updateState({
                            therapy_master_data: Data?.map((element, index) => ({ ...element, sno: index + 1 })),
                            is_loader: false
                        })
                    }
                }).catch(e => {
                    updateState({ is_loader: false })
                    errorMessage(e?.response?.data?.message || e?.message)
                })
        } catch (e) {
            updateState({ is_loader: false })
            errorMessage(e.message)
        }
    }

    // const textBox = (label, name, width, disable = false) => {
    //     return (
    //         <Box>
    //             <TextField
    //                 size='small'
    //                 name={name}
    //                 disabled={disable}
    //                 inputProps={{ maxLength: 250 }}
    //                 value={state[name] || ""}
    //                 sx={{ width: width, marginRight: '0.3vw' }}
    //                 label={label}
    //                 onChange={(e) => { updateState({ [name]: e.target.value }) }}
    //                 variant="outlined"
    //             />
    //         </Box>
    //     )
    // }

    const tableView = () => {

        const grpInactive = () => {
            updateState({ is_inactive: true })
        }

        const gridToolBar = () => {
            return (
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} height={'3.1vw'}>
                    <GridToolbarQuickFilter
                        sx={{ flexWrap: 'nowrap' }}
                        isInactive={true}
                    />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            const selectedIDs = new Set(id);
            const selectedRows = state?.therapy_master_data?.filter((row) => selectedIDs.has(row.sno));
            const FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            updateState({ checkbox_list: id, selected_ids: FinalData })
        }

        const columns = [
            {
                field: 'role_code', headerName: 'Role Code', flex: 0.2,
                renderCell: ({ row }) => (<Box component={'div'}>{row?.role_code ? row?.role_code : '-'}</Box>)

            },
            {
                field: 'role_name', headerName: 'Role Name', flex: 0.5,
                renderCell: ({ row }) => (row.role_name ? row.role_name?.length > 100 ?
                    <Tooltip placement="top" title={row.role_name}><Typography fontSize={'0.9vw'}>{row.role_name?.slice(0, 100) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{row.role_name}</Typography> : '-')

            },
            {
                field: 'action', headerName: 'Action', flex: 0.1,
                renderCell: ({ row }) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw"
                                disable={state?.selected_ids?.length > 0}
                                onClick={() =>
                                    history.push("/Settings/UserAccess/UserSettings/RoleMaster/AddRole",
                                        {
                                            role_name: row.role_name || "",
                                            role_code: row.role_code || null,
                                            is_active: row.is_active,
                                            edit_id: row.id,
                                            module_access: row?.role_access || [],
                                        })
                                } />
                        </Stack>
                    </Stack>)

            },
        ]
        return (
            <Box sx={{ height: '61vh', marginTop: '.5vw' }}>
                <DataGrid
                    rows={state.therapy_master_data}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={state.page}
                    pageSize={state.pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { updateState({ page: newPage }) }}
                    onPageSizeChange={(newPageSize) => { updateState({ pageSize: newPageSize }) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={state.is_loader}
                />
            </Box>
        )
    }

    const clearFunction = () => {
        updateState({
            role_name: '',
            role_code: null,
            is_active: true,
            edit_id: null,
            is_loader: false,
            selected_ids: [],
            is_inactive: false,
            checkbox_list: [],
            is_delete: false,
        })
    }

    const addTherapyDetails = () => {
        try {
            const data = {
                'role_name': state.role_name,
                'is_active': state.is_active,
            }
            if (state?.edit_id) {
                data["id"] = state?.edit_id
            }
            RestAPIService[state.edit_id ? "updateWithOutId" : "create"](data, Serviceurls.ROLE_MASTER_GET)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        clearFunction()
                        getRoleMasterList()
                    }
                }).catch(e => {
                    updateState({ is_loader: false })
                    errorMessage(e?.response?.data?.message || e?.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    // const deleteTherapyMaster = () => {
    //     try {
    //         RestAPIService.delete(`${Serviceurls.ROLE_MASTER_GET}?id=${state.deleted_ids || []}`, {})
    //             .then((response) => {
    //                 if (response.data.status === 'success') {
    //                     successMessage(response.data.message)
    //                     getRoleMasterList()
    //                     clearFunction()
    //                 }
    //             }).catch(e => {
    //                 errorMessage(e?.response?.data?.message || e?.message)
    //             })
    //     } catch (e) {
    //         errorMessage(e.message)
    //     }
    // }

    // const deleteClsPop = () => {
    //     updateState({
    //         is_delete: false,
    //         checkbox_list: [],
    //         deleted_ids: [],
    //     })
    // }

    const inactiveTherapyMaster = () => {
        try {
            RestAPIService.updateWithOutId(`${Serviceurls.ROLE_MASTER_GET}?id=${state.selected_ids || []}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getRoleMasterList()
                        clearFunction()
                    }
                }).catch(e => {
                    errorMessage(e?.response?.data?.message || e?.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const inactiveClsPop = () => {
        updateState({
            is_inactive: false,
            checkbox_list: [],
            deleted_ids: [],
        })
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ height: '6.5vh', width: '93vw', backgroundColor: 'white', padding: '.6vw', }}>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '1vw', flexWrap: 'nowrap' }}>
                    <Box>
                        <Button size='small' variant='contained'
                            onClick={() => {
                                if (state.edit_id) {
                                    addTherapyDetails();
                                } else {
                                    history.push("/Settings/UserAccess/UserSettings/RoleMaster/AddRole");
                                }
                            }}>
                            {state.edit_id ? "Update" : "Add"}
                        </Button>
                    </Box>
                </Box>
            </Box>
            <Box component={'div'} sx={{ height: '61vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            {state.isErrorMsg && <ToastMsg severity={"error"} msg={state.isErrorMsgText} msgPop={msgClose.bind(this)} />}
            {state.successMsg && <ToastMsg severity={"success"} msg={state.successMsgText} msgPop={msgClose.bind(this)} />}
            {state.is_inactive &&
                <DeletePopup
                    DeletTitle={`Are you sure, Do you want to inActive this therapy ?`}
                    AlertNote={"If you inActive this therapy, the associated therapy time will also be inActive6."}
                    deleteAlertPopupClose={inactiveClsPop.bind(this)}
                    removeData={inactiveTherapyMaster.bind(this)}
                />}
        </Box>
    )
}
export default RoleMaster